import {TSSerializable} from './TSSerializable';
import TSAbstractEntity from './TSAbstractEntity';

export default class TSBankverbindung extends TSAbstractEntity implements TSSerializable<TSBankverbindung> {

    private _bankName: string;
    private _bankPLZ: string;
    private _bankOrt: string;
    private _inhaberName: string;
    private _inhaberPLZ: string;
    private _inhaberOrt: string;
    private _iban: string;

    public get bankName(): string {
        return this._bankName;
    }

    public set bankName(value: string) {
        this._bankName = value;
    }

    public get bankPLZ(): string {
        return this._bankPLZ;
    }

    public set bankPLZ(value: string) {
        this._bankPLZ = value;
    }

    public get bankOrt(): string {
        return this._bankOrt;
    }

    public set bankOrt(value: string) {
        this._bankOrt = value;
    }

    public get iban(): string {
        return this._iban;
    }

    public set iban(value: string) {
        this._iban = value;
    }

    get inhaberName(): string {
        return this._inhaberName;
    }

    set inhaberName(value: string) {
        this._inhaberName = value;
    }

    get inhaberPLZ(): string {
        return this._inhaberPLZ;
    }

    set inhaberPLZ(value: string) {
        this._inhaberPLZ = value;
    }

    get inhaberOrt(): string {
        return this._inhaberOrt;
    }

    set inhaberOrt(value: string) {
        this._inhaberOrt = value;
    }

    deserialize(restObject: any): TSBankverbindung {
        this.bankName = restObject.bankName;
        this.bankPLZ = restObject.bankPLZ;
        this.bankOrt = restObject.bankOrt;
        this.inhaberName = restObject.inhaberName;
        this.inhaberPLZ = restObject.inhaberPLZ;
        this.inhaberOrt = restObject.inhaberOrt;
        this.iban = restObject.iban;
        return this;
    }

    serialize(restObject: any): any {
        restObject.bankName = this.getOptionalString(this.bankName);
        restObject.bankPLZ = this.getOptionalString(this.bankPLZ);
        restObject.bankOrt = this.getOptionalString(this.bankOrt);
        restObject.inhaberName = this.inhaberName;
        restObject.inhaberPLZ = this.inhaberPLZ;
        restObject.inhaberOrt = this.inhaberOrt;
        restObject.iban = this.iban;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSBankverbindung.ts